import useCreateAdditional from 'modules/additionals/hooks/use-create-additional';
import {
  AdditionalProps,
  translatedAdditionalProps,
} from 'modules/additionals/types';
import useBaseAdditionalsSelect from 'modules/base-additionals/hooks/use-base-additionals-select';
import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateAdditional: React.FC = () => {
  const {id} = useParams();
  const formContext = useForm({
    defaultValues: {active: true, additionalGroupId: id} as Omit<
      AdditionalProps,
      'additionalGroup'
    >,
  });
  const [baseAdditional, setBaseAdditional] = useState<string>();
  const {getSelect, getSwitch, getTextArea, getPriceInput, getImagePicker} =
    useFormInputs<AdditionalProps>();
  const {data, isLoading} = useBaseAdditionalsSelect();

  const onFormStateChange = ({name}: AdditionalProps) => {
    if (baseAdditional && baseAdditional === name) return;

    setBaseAdditional(name);

    const isBaseAdditional = data?.find(({value}) => name === value);

    if (!isBaseAdditional) return;

    formContext.setValue('description', isBaseAdditional.data.description);
  };

  const handleSubmit = (additional: AdditionalProps) => {
    const formData = new FormData();

    const name =
      data?.find(({value}) => additional.name === value)?.label ??
      additional.name;

    formData.append('name', name);
    formData.append('description', additional.description ?? '');
    formData.append('price', String(additional.price));
    formData.append('active', String(additional.active));
    formData.append('additionalGroupId', id!);
    if (additional.image && (additional.image as any) instanceof File)
      formData.append('image', additional.image);

    return formData;
  };

  return (
    <Creation<AdditionalProps>
      titleBar={{title: 'Cadastrar adicional'}}
      {...{formContext, onFormStateChange, handleSubmit}}
      onSubmit={useCreateAdditional}
      inputs={[
        getSelect({
          name: 'name',
          data,
          isLoading,
          creatable: true,
        }),
        getTextArea({name: 'description'}),
        getSwitch({
          name: 'active',
        }),
        getPriceInput({name: 'price'}),
        getImagePicker({name: 'image', label: 'Imagem'}),
      ]}
      translationKey={translatedAdditionalProps}
    />
  );
};

export default CreateAdditional;
